import { NgModule } from "@angular/core";
import { ReportComponent } from "./report.component";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { SelectButtonsModule } from "../../_component/select-buttons/select-buttons.module";
import { UploadAttachmentModule } from "../../_component/upload-attachment/upload-attachment.module";
import { UserWithAvatarModule } from "src/app/app/_component/user-with-avatar/user-with-avatar.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    SelectButtonsModule,
    UploadAttachmentModule,
    UserWithAvatarModule,
    SharedDirectivesModule,
    LoadingStiModule
  ],

  declarations: [ReportComponent],
  exports: [ReportComponent],
})
export class ReportModule {}
